// extracted by mini-css-extract-plugin
module.exports = {"root":"index-root-W2G_x","loading":"index-loading-174z7"};